import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import StestPageHero from "./components/StestPageHero";
import StestIntroSection from "./components/StestIntroSection";
import StestWhyChoose from "./components/StestWhyChoose";
import StestServicesSection from "./components/StestServicesSection";
import StestProcess from "./components/StestProcess";
import StestTools from "./components/StestTools";
import WdevStats from "../WebDevelopmentPage/components/WdevStats";
import WdevTestimonials from "../WebDevelopmentPage/components/WdevTestimonials";
import WdevCtaBanner from "../WebDevelopmentPage/components/WdevCtaBanner";
import "../WebDevelopmentPage/web-development.css";
import "./software-testing.css";

const SoftwareTestingPage: React.FC = () => {
  useEffect(() => {
    document.title = "Software Testing Services | WebTech Software Solutions Bangalore";
    const description =
      "Top functional, performance, regression, and mobile testing company in Bangalore. WebTech delivers quality assurance for web and mobile applications.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="wdev-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <StestPageHero />
            <StestIntroSection />
            <StestWhyChoose />
            <StestServicesSection />
            <StestProcess />
            <StestTools />
            <WdevStats />
            <WdevTestimonials />
            <WdevCtaBanner />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default SoftwareTestingPage;
